import { gql } from '@apollo/client';

export const ESSAY_LIST = gql`
  query essayList($idx: Int, $dateStr: String, $endDateStr: String, $lesson_code: String, $user_lesson_idx: Int) {
    essayList(idx: $idx, dateStr: $dateStr, endDateStr: $endDateStr, lesson_code: $lesson_code, user_lesson_idx: $user_lesson_idx) {
      idx
      title
      content
      lesson_code
      status
      idate
      book_lesson {
        title
      }
      user_lesson {
        idx
      }
    }
  }
`;
